module.exports = __webpack_public_path__ + "static/media/11.efaa24de.jpg";